import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Input, Spinner } from '@nextui-org/react'
import { GET, POST } from '../../../utils/requests';
import Paginations from '../../../components/Pagination';
import { order_uri } from '../../../utils/url';
import {TYPES} from '../../../utils/types'
import moment from "moment";
import { FaCheck } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from 'react-toastify';
import Tailan from '../../../components/Tailan';

const MONTHS = [
  { value: 1, label: '1-р сар' },
  { value: 2, label: '2-р сар' },
  { value: 3, label: '3-р сар' },
  { value: 4, label: '4-р сар' },
  { value: 5, label: '5-р сар' },
  { value: 6, label: '6-р сар' },
  { value: 7, label: '7-р сар' },
  { value: 8, label: '8-р сар' },
  { value: 9, label: '9-р сар' },
  { value: 10, label: '10-р сар' },
  { value: 11, label: '11-р сар' },
  { value: 12, label: '12-р сар' },
];

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: currentYear - 2019 }, (_, i) => currentYear - i);

const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate();

const AchaaOlgoson = () => {
  const [load, setLoad] = useState(false);
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({limit:20, all:'', totalPage:'',phone_or_trackcode:'',barcode:''});
  const [pay, setPay] = useState({onepay:'', allpay:''});
  const [page, setPage] = useState(1);
  const [checkedValue, setValue] = useState([]);
  const [checkedTracks, setCheckedTracks] = useState([]);
  const [checkload, setCheckload] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedDay, setSelectedDay] = useState(new Date().getDate());
  const [reportSummary, setReportSummary] = useState(null);
  const [reportLoad, setReportLoad] = useState(false);

  const daysInMonth = getDaysInMonth(selectedYear, selectedMonth);
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  useEffect(() => {
    Get();
  }, [page]);

  const handleYearChange = (year) => {
    setSelectedYear(year);
    const maxDay = getDaysInMonth(year, selectedMonth);
    if (selectedDay > maxDay) setSelectedDay(maxDay);
    setReportSummary(null);
  };

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
    const maxDay = getDaysInMonth(selectedYear, month);
    if (selectedDay > maxDay) setSelectedDay(maxDay);
    setReportSummary(null);
  };

  const GetReport = async () => {
    setReportLoad(true);
    const res = await GET(order_uri+`/tailan-daily?year=${selectedYear}&month=${selectedMonth}&day=${selectedDay}&status=${TYPES.CONFIRM}`);
    if (res?.status === 200) {
      setReportSummary(res.data.summary);
    }
    setReportLoad(false);
  };

  const Get = async () => {
    setLoad(true);
    const b = await GET(order_uri+`/list-new?page=${page}&limit=${pagination.limit}&status=${TYPES.CONFIRM}&phone_or_trackcode=${pagination.phone_or_trackcode}&barcode=${pagination.barcode}`);
    setData(b.data.data);
    setPagination({...pagination, all:b.data.all, totalPage:b.data.totalPage});
    setLoad(false);
  };

  const Sub = async () => {
    setCheckload(true);
    const b = await POST({uri: order_uri+'/olgolt', data:checkedTracks});
    if(b.status === 200){
      setCheckedTracks([]);
      toast.success("Амжилттай");
      Get();
    }else{
      toast.success("Алдаа");
    }
    setCheckload(false);
  };

  const callback =()=> {
    Get();
  }
  
  const changePage = (page) => {
    setPage(page);
  };
  
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      Get();
    }
  };
  
  const handleSearch = (event) => {
    if (event.key === 1) {
      setPagination({...pagination, phone_or_trackcode:event.value, barcode: ''});
    }
    if (event.key === 2) {
      setPagination({...pagination, phone_or_trackcode:'', barcode: event.value});
    }
  };


  return (
    <div>
      <div>

        <div className="mr-2 mt-2 font-Roboto">
          <div className="overflow-x-auto shadow-md sm:rounded-md grid col-span-5">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden ">
                <div className='bg-[#080852] rounded-md my-2 p-4 flex justify-between items-center text-white flex-wrap gap-4'>
                  <h1 className='text-lg font-bold'>Олгосон ачаа</h1>
                  <div className='flex items-center gap-2 flex-wrap'>
                    <select
                      value={selectedYear}
                      onChange={(e) => handleYearChange(Number(e.target.value))}
                      className='bg-white text-black p-2 rounded text-sm'
                    >
                      {YEARS.map((year) => (
                        <option key={year} value={year}>{year} он</option>
                      ))}
                    </select>
                    <select
                      value={selectedMonth}
                      onChange={(e) => handleMonthChange(Number(e.target.value))}
                      className='bg-white text-black p-2 rounded text-sm'
                    >
                      {MONTHS.map((month) => (
                        <option key={month.value} value={month.value}>{month.label}</option>
                      ))}
                    </select>
                    <select
                      value={selectedDay}
                      onChange={(e) => { setSelectedDay(Number(e.target.value)); setReportSummary(null); }}
                      className='bg-white text-black p-2 rounded text-sm'
                    >
                      {days.map((day) => (
                        <option key={day} value={day}>{day}-ны өдөр</option>
                      ))}
                    </select>
                    <Button size='sm' className='bg-green-600 text-white' onClick={GetReport} isLoading={reportLoad}>
                      Харах
                    </Button>
                    <Tailan type={TYPES.CONFIRM} name="Олгосон ачаа"/>
                  </div>
                </div>
                {
                  reportSummary &&
                  <div className='bg-white p-4 rounded-md shadow-sm mb-2'>
                    <h2 className='text-md font-bold text-gray-800 mb-3'>
                      {reportSummary.date} өдрийн тайлан
                    </h2>
                    <div className='grid grid-cols-2 gap-4'>
                      <div className='bg-blue-50 p-3 rounded-lg text-center'>
                        <p className='text-sm text-gray-600'>Олгосон</p>
                        <p className='text-xl font-bold text-[#080852]'>{reportSummary.totalCount} ширхэг</p>
                      </div>
                      <div className='bg-yellow-50 p-3 rounded-lg text-center'>
                        <p className='text-sm text-gray-600'>Нийт үнэ</p>
                        <p className='text-xl font-bold text-yellow-700'>{Intl.NumberFormat().format(reportSummary.totalPayment)}₮</p>
                      </div>
                    </div>
                  </div>
                }
              <div className='bg-white p-4'>
                <div className='flex items-center gap-2'>
                  <input onKeyDown={handleKeyDown} size='' className='border rounded-lg mt-2 focus:border-1 focus:border-blue-600 outline-none w-full p-2 bg-gray-100' 
                  placeholder='Утсаар хайлт хийх' onChange={(e) => handleSearch({value: e.target.value, key: 1})}/>
                  <input onKeyDown={handleKeyDown} size='' className='border rounded-lg mt-2 focus:border-1 focus:border-blue-600 outline-none w-full p-2 bg-gray-100' 
                  placeholder='Бар кодоор хайлт хийх' onChange={(e) => handleSearch({value: e.target.value, key: 2})}/>
                </div>
              {/* <div className='mt-2'>
                <AllPayModal data={checkedValue} callback={callback}/>
              </div> */}
              </div>
              <div className='overflow-auto'>
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      {/* <th scope="col" className="p-4 text-sm font-normal">
                      </th> */}
                      <th scope="col" className="p-4 text-sm font-normal">
                        #
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Утас
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Бар код
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Олгосон огноо
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Тоо
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Үнэ
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Тайлбар
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                       
                      </th>
                    </tr>
                  </thead>
                  {
                    load?
                    <div className='flex items-center justify-center  p-4'>
                      <Spinner/>
                      <h1 className=''>Уншиж байна ...</h1>
                    </div>
                    :
                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                      {
                        data.map((item, index) => {
                          return(
                            <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                                <td className="p-2 w-4 text-center">
                                  {index+1}
                                </td>
                                <td className="py-2 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white flex flex-col">
                                  <label className=''>{item.phone_no}</label>
                                </td>
                                <td className="py-2 px-6 text-md font-bold text-gray-800  dark:text-white text-overflow">{item.trackcode}</td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{moment(item.date).format('YYYY-MM-DD HH:mm:ss')}</td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{item.quantity}</td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{Intl.NumberFormat().format(item.payment)}₮</td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{item.explanation}</td>
                                
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow flex gap-2">
                                  {/* <OrderDetailModal prod={item} callback={callback}/> */}
                                  {/* <div className='bg-gray-200 p-2 rounded-md hover:bg-gray-300 cursor-pointer' onClick={()=> handleCheckClick(item)}>
                                   <FaCheck size={20}/>
                                  </div> */}
                                </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  }
                </table>
                </div>
                {
                  data.length === 0 &&
                  <div className='bg-white pt-8 text-center flex items-center justify-center flex-col'>
                    <img className='h-24' src='../../empty.gif'/>
                    <h1 className=''>Хоосон байна...</h1>
                  </div>
                }
               <Paginations initialPage={page} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default AchaaOlgoson


